import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getCurrentDevice({ commit }, { token }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/device",
        method: "GET",
        params: { token },
      });
      let data = response.data;
      commit(MutationsType.SET_DEVICE, data.data);
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async handleDeviceNotifications({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/device/notifications",
        method: "POST",
        data: payload,
      });
      let data = response.data.data;
      commit(MutationsType.SET_DEVICE, {
        token: data.token,
        notification_types: data.notification_types,
        allow: data.allow,
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async testDeviceNotification({}, { type }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/device/notifications/${type}/test`,
        method: "POST",
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};
